export enum ENUM_LINK_LAYOUT {
  ICON = 'ICON',
  LINE = 'LINE',
  SMALL = 'SMALL',
  DEFAULT = 'DEFAULT',
}
